import {memo} from 'react'
import clsx from 'clsx'

import {cssTheme} from '../theme'
import {css} from '../theme/css'

const dividerClass = css`
  border-bottom: 1px solid ${cssTheme.default.day.line};
`

const dividerWithErrorClass = css`
  border-color: ${cssTheme.colors.red.toxic};
`

/** Пропсы компонента Divider */
type DividerProps = JSX.IntrinsicElements['div'] & {
  /**
   * Если true, подсвечивает дивайдер красным
   * @default false
   */
  isInvalid?: boolean;
}

export const Divider = memo(({className, isInvalid = false, ...props}: DividerProps) => (
  <div className={clsx(className, dividerClass, { [dividerWithErrorClass]: isInvalid })} {...props} />
))
